export enum NewPaymentErrorDescription {
  MaximumCardReached = 'User reached the maximum amount of cards allowed per account',
  NetworkIssues = 'Network issues',
  CardDuplicated = 'Card duplicated',
  FlowDropped = 'User dropped the flow voluntarily',
  BankDuplicated = 'Bank account duplicated',
}


// WEBPACK FOOTER //
// ./src/model/types/newPayment-error-description.ts